import { Controller, useFormContext } from 'react-hook-form';
import { InfoMessage, Message, RadioButton } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import handleValidationIndicator from '@@viewCommonComponents/controlled/helpers/handleValidationIndicator.js';
import { useEffect } from 'react';
import { either, isEmpty, isNil, prop } from 'ramda';

const ControlledRadioButton = ({
  name,
  form,
  rules,
  label,
  defaultValue,
  message,
  containerClassName = 'w-full',
  isResponsiveCol = false,
  withIndicator = true,
  triggerOnChange = false,
  extraChange = () => {
  },
  isDisplayed = true,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }

  const {
    setValue,
    getValues
  } = useFormContext();

  useEffect(() => {
    if (!isNil(defaultValue)) {
      const currentValue = getValues(name);

      if (either(isNil, isEmpty)(currentValue)) {
        setValue(name, defaultValue);
      }
    }
  }, [defaultValue, name, setValue]);

  useEffect(() => {
    form.trigger(name);

    return () => {
      form.clearErrors(name);
    };
  }, [form.trigger, form.clearErrors, name]);

  const $label = prop('required', rules) && label ? `${label} *` : label;
  const errorMessage = getErrorMessage(form.formState.errors, name);
  return (
    <div className={containerClassName}>
      {$label}
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={({ field }) => {
          const handleChange = async (value) => {
            field.onChange(value);
            if (extraChange) {
              extraChange(value);
            }
            if (triggerOnChange) await form.trigger();
          };

          return (
            <RadioButton
              className="mb-4"
              {...field}
              {...extraProps}
              isResponsiveCol={isResponsiveCol}
              withIndicator={withIndicator}
              error={handleValidationIndicator(
                field.value?.toString(),
                rules,
                errorMessage
              )}
              onChange={handleChange}
            />
          );
        }}
      />
      <Message variant="error" label={errorMessage} />
      {message && <InfoMessage iconName={'lightbulb'}>{message}</InfoMessage>}
    </div>
  );
};

export default ControlledRadioButton;
